import axios from '@axios'

/**
 * @param {{ context: import('vuex/types/index')['ActionContext'], stateName: string }} actionTrigger
 * @param {('get'|'post'|'put'|'delete')} method The HTTP method to use with axios
 * @param {string} endpoint The endpoint to call
 * @param {any} [data] The data to send to the endpoint
 * @returns {Promise<import('axios').AxiosResponse>} The response from the endpoint
 */
async function autoResolve(actionTrigger, method, endpoint, data) {
    const response = await axios[method](endpoint, data)
    if (actionTrigger.stateName) {
        actionTrigger.context.commit(actionTrigger.stateName, response.data)
    }
    return response
}
/// @deprecated
export default {
    namespaced: true,
    state: {
        // Hint: Here goes the variables that are stored 'globally'
        cotizaciones: [],
        cotizacion: {},
        ordenesCompra: [],
        ordenesEntrega: [],
        categoriasServicio: [],
        lineasServicio: [],
        servicios: [],
        jefesArea: [],
        duenoCategoria: [],
        responsableAprobacion: [],
        asignacionCategoria: [],
        detalle: [],
        conceptosAir: [],
        sustentosTributarios: [],
    },
    getters: {
        getCotizaciones(state) {
            return state.cotizaciones
        },

        getCotizacion(state) {
            return state.cotizacion
        },

        getOrdenesCompra(state) {
            return state.ordenesCompra
        },

        getOrdenesEntrega(state) {
            return state.ordenesEntrega
        },

        getCategoriasServicios(state) {
            return state.categoriasServicio
        },

        getLineasServicio(state) {
            return state.lineasServicio
        },

        getServicios(state) {
            return state.servicios
        },

        getHistorialAprobacionesOC(state) {
            return state.historialAprobacionesOC
        },

        getHistorialCostos(state) {
            return state.historialCostos
        },

        getJefesdeArea(state) {
            return state.jefesArea
        },

        getAsignacionUsuario(state) {
            return state.duenoCategoria
        },

        getResponsableAprobacion(state) {
            return state.responsableAprobacion
        },

        getAsignacionUsuarioCategoria(state) {
            return state.asignacionCategoria
        },
        getDetallesCotizacion(state) {
            return state.detalle
        },
        getConceptosAir(state) {
            return state.conceptosAir
        },
        getSustentosTributarios(state) {
            return state.sustentosTributarios
        },
    },
    mutations: {
        setCotizaciones(state, cotizaciones) {
            state.cotizaciones = cotizaciones
        },

        setCotizacion(state, cotizacion) {
            state.cotizacion = cotizacion
        },

        setOrdenesCompra(state, ordenesCompra) {
            state.ordenesCompra = ordenesCompra
        },

        setOrdenesEntrega(state, ordenesEntrega) {
            state.ordenesEntrega = ordenesEntrega
        },

        setCategoriasServicios(state, categoriasServicio) {
            state.categoriasServicio = categoriasServicio
        },

        setLineasServicios(state, lineasServicio) {
            state.lineasServicio = lineasServicio
        },

        setServicios(state, servicios) {
            state.servicios = servicios
        },

        setHistorialAprobacionesOC(state, historialAprobacionesOC) {
            state.historialAprobacionesOC = historialAprobacionesOC
        },

        setHistorialCostos(state, historialCostos) {
            state.historialCostos = historialCostos
        },

        setJefesdeArea(state, jefesArea) {
            state.jefesArea = jefesArea
        },

        setDuenoCategoria(state, duenoCategoria) {
            state.duenoCategoria = duenoCategoria
        },

        setResponsableAprobacion(state, responsableAprobacion) {
            state.responsableAprobacion = responsableAprobacion
        },

        setAsignacionUsuarioCategoria(state, asignacionCategoria) {
            state.asignacionCategoria = asignacionCategoria
        },
        setDetallesCotizacion(state, detalle) {
            state.detalle = detalle
        },
        setConceptosAir(state, conceptosAir) {
            state.conceptosAir = conceptosAir
        },
        setSustentosTributarios(state, sustentosTributarios) {
            state.sustentosTributarios = sustentosTributarios
        },
    },
    actions: {
        /* COTIZACIONES */
        postCotizacion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/compras/cotizaciones', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCotizaciones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/cotizaciones', {
                        params: {
                            search: data?.search,
                            estado: data?.estado,
                            tipo_cotizacion: data?.tipo_cotizacion,
                            rangoFecha: data?.rangoFecha,
                            per_page: data?.pagination?.per_page,
                            page: data?.pagination?.page,
                            paginated: data?.paginated ?? 0,
                            id_proveedor: data?.id_proveedor,
                            id_cotizacion: data?.id_cotizacion,
                            id_solicitud: data?.id_solicitud,
                            id_establecimiento: data?.id_establecimiento,
                        },
                    })
                    .then(response => {
                        commit('setCotizaciones', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCotizacionById({ commit }, id_cotizacion) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/compras/cotizaciones/${id_cotizacion}`)
                    .then(response => {
                        commit('setCotizacion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        putCotizacion(_, { id_cotizacion, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/cotizaciones/${id_cotizacion}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* ÓRDENES DE COMPRA */
        fetchOrdenesCompra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/ordenes-compra', {
                        params: data,
                    })
                    .then(response => {
                        commit('setOrdenesCompra', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchOrdenCompraxId({ commit }, id_orden_compra) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/compras/ordenes-compra/${id_orden_compra}`)
                    .then(response => {
                        commit('setOrdenesCompra', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchOrdenesCompraApproval({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/ordenes-compra/por-aprobar', {
                        params: data,
                    })
                    .then(response => {
                        commit('setOrdenesCompra', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchHistorialAprobacionesOC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/ordenes-compra/historial-aprobaciones', { params: data })
                    .then(response => {
                        commit('setHistorialAprobacionesOC', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postOrdenCompra(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/compras/ordenes-compra', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postOrdenesCompra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/compras/ordenes-compra/masivo', data)
                    .then(response => {
                        commit('setOrdenesCompra', response.data.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postActualizaOc(_, { id_orden_compra, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/ordenes-compra/${id_orden_compra}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchHistorialCostos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/ordenes-compra/historial-costos', { params: data })
                    .then(response => {
                        commit('setHistorialCostos', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        aprobarOrdenesCompra(_, { id_orden_compra, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/ordenes-compra/${id_orden_compra}/aprobacion`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSubirArchivoOC(_, { id_orden_compra, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-compra/${id_orden_compra}/reporte`, payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoPendiente(_, id_orden_compra) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-compra/${id_orden_compra}/enviar-correo-pendiente`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoAprobadoOC(_, id_orden_compra) {
            return new Promise((resolve, reject) => {
                axios

                    .post(`/api/auth/compras/ordenes-compra/${id_orden_compra}/enviar-correo-aprobado`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoRechazadoOC(_, id_orden_compra) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-compra/${id_orden_compra}/enviar-correo-rechazado`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoAnuladoOC(_, id_orden_compra) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-compra/${id_orden_compra}/enviar-correo-anulado`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* ÓRDENES DE ENTREGA */
        fetchOrdenesEntrega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/ordenes-entrega', {
                        params: data,
                    })
                    .then(response => {
                        commit('setOrdenesEntrega', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchOrdenEntregaxId({ commit }, id_orden_entrega) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}`)
                    .then(response => {
                        commit('setOrdenesEntrega', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearOrdenEntrega(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/compras/ordenes-entrega', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarOrdenEntrega(_, { id_orden_entrega, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        receptarOrdenEntrega(_, { id_orden_entrega, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}/receptar`, {
                        ...data,
                        _method: 'PUT',
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSubirArchivoOE(_, { id_orden_entrega, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}/reporte`, payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoReceptadoOE(_, id_orden_entrega) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}/enviar-correo-receptado`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchEnviarCorreoPendienteOE(_, id_orden_entrega) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}/enviar-correo-pendiente`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoParcialOE(_, id_orden_entrega) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}/enviar-correo-parcial`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEnviarCorreoRechazoOE(_, id_orden_entrega) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/ordenes-entrega/${id_orden_entrega}/enviar-correo-rechazado`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* CATEGORÍAS SERVICIOS */
        fetchCategoriasServicios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/servicios/categorias', {
                        params: data,
                    })
                    .then(response => {
                        commit('setCategoriasServicios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearCategoria(context, data) {
            return autoResolve({ context }, 'post', '/api/auth/compras/servicios/categorias', data)
        },

        desactivarCategoria(_, id_categoria) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/compras/servicios/categorias/${id_categoria}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarCategoria(_, { id_categoria, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/servicios/categorias/${id_categoria}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCategoriaServicioById({ commit }, id_categoria) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/compras/servicios/categorias/${id_categoria}`)
                    .then(response => {
                        commit('setCategoriasServicios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* LÍNEAS SERVICIOS */
        fetchLineasServicios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/servicios/lineas', { params: data })
                    .then(response => {
                        commit('setLineasServicios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearLinea(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/compras/servicios/lineas', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarLinea(_, { id_linea, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/servicios/lineas/${id_linea}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarLinea(_, id_linea) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/compras/servicios/lineas/${id_linea}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchLineaServicioById({ commit }, id_linea) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/compras/servicios/lineas/${id_linea}`)
                    .then(response => {
                        commit('setLineasServicios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* SERVICIOS */
        fetchServicios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/servicios', {
                        params: data,
                    })
                    .then(response => {
                        commit('setServicios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        guardarTributacionContable(_, { id_servicio, data }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/compras/servicios/${id_servicio}/configuracion`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearServicio(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/compras/servicios', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarServicio(_, { id_servicio, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/servicios/${id_servicio}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarServicio(_, id_servicio) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/compras/servicios/${id_servicio}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchServicioByID({ commit }, id_servicio) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/compras/servicios/${id_servicio}`)
                    .then(response => {
                        commit('setServicios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* JEFES DE ÁREA */
        fetchJefesDeAreas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/jefes-area', {
                        params: data,
                    })
                    .then(response => {
                        commit('setJefesdeArea', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchJefeDeArea({ commit }, id_jefe_area) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/compras/jefes-area/${id_jefe_area}`)
                    .then(response => {
                        commit('setJefesdeArea', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        agregarJefeDeArea(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/compras/jefes-area', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        actualizarJefeDeArea(_, { id_jefe_area, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/compras/jefes-area/${id_jefe_area}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarJefeDeArea(_, id_jefe_area) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/compras/jefes-area/${id_jefe_area}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchDuenoCategoria({ commit }, data) {
            const response = await axios.get('/api/auth/compras/dueno-categoria', { params: data })
            commit('setDuenoCategoria', response.data)
            return response.data
        },

        async fetchEstadoDueno(_, id) {
            const response = await axios.delete(`/api/auth/compras/dueno-categoria/${id}/estado-dueno`)
            return response
        },

        async fetchAgregarDueno(_, data) {
            const response = await axios.postForm('/api/auth/compras/dueno-categoria/agregar-dueno', data)
            return response
        },

        async fetchEditarDueno(_, { id, ...data }) {
            const response = await axios.put(`/api/auth/compras/dueno-categoria/${id}`, data)
            return response
        },

        async fetchResponsableAprobacion({ commit }, data) {
            const response = await axios.get('/api/auth/compras/responsable-aprobacion', { params: data })
            commit('setResponsableAprobacion', response.data)
            return response.data
        },

        async fetchEstadoResponsable(_, id_parametro) {
            const response = await axios.delete(
                `/api/auth/compras/responsable-aprobacion/${id_parametro}/estado-responsable`
            )
            return response
        },

        async fetchEditarResponsable(_, data) {
            const response = await axios.put('/api/auth/compras/responsable-aprobacion/update-resp', data)
            return response
        },

        async fetchAgregarResponsable(_, data) {
            const response = await axios.postForm('/api/auth/compras/responsable-aprobacion/agregar-responsable', data)
            return response
        },

        async fetchAsignacionUsuarioCategoria({ commit }, data) {
            const response = await axios.get('/api/auth/compras/asignacion-categoria', { params: data })
            commit('setAsignacionUsuarioCategoria', response.data)
            return response.data
        },

        async fetchEliminarPermisoCategoria(_, id) {
            const response = await axios.delete(`/api/auth/compras/asignacion-categoria/${id}`)
            return response
        },

        async fetchAgregarPermisoCategoria(_, data) {
            const response = await axios.postForm('/api/auth/compras/asignacion-categoria/agregar-permiso', data)
            return response
        },

        async fetchEditarPermisoCategoria(_, { id, ...data }) {
            const response = await axios.put(`/api/auth/compras/asignacion-categoria/${id}`, data)
            return response
        },
        async fetchDetalle({ commit }, data) {
            const response = await axios.get('/api/auth/compras/cotizaciones/detalle', { params: data })
            commit('setDetallesCotizacion', response.data)
            return response.data
        },

        async fetchUpdateRecepcionOC(_, id_orden_compra) {
            const response = await axios.put(`/api/auth/compras/ordenes-compra/${id_orden_compra}/actualizar-recepcion`)
            return response
        },

        fetchSustentosTributarios(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/compras/servicios/lineas/sustentos-tributarios', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
